import Vue from 'vue';

const success = (response, context, bookingIndex, type, fromCalendar) => {
  if (!fromCalendar) {
    toastr.success(response.status);
    const nameCapitalized = type.charAt(0).toUpperCase() + type.slice(1);
    context[`bookings${nameCapitalized}s`][bookingIndex][`assigned_to_${type}`] = response.booking[`assigned_to_${type}`];
    context[`bookings${nameCapitalized}s`][bookingIndex][`${type}_assign`] = response.booking[`${type}_assign`];
    context[`bookings${nameCapitalized}s`][bookingIndex][`${type}_assign_status`] = response[`${type}_assign_status`];
    context.statusCounts = {
      toBeAssigned: 0,
      assigned: 0,
      done: 0,
      cleaningFast: 0,
      cancelled: 0
    };
    context.calculateCounts();
  } else {
    toastr.success(response.status);
  }
};

const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, data, bookingIndex, type, fromCalendar = false) => {
  return Vue.$http.post('bookings/assign-team-member-web', data)
    .then(response => {
      if(response && response.status === 200) {
        success(response.data, context, bookingIndex, type, fromCalendar);
      }
    }).catch(error => {
        failed(error, context);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/booking/assignTeamMemberToBooking.js